import React, { useState, useEffect, useRef } from 'react';
import { Box, Button, Modal, Typography } from '@blueprint/ui';
import { useTranslation } from 'react-i18next';
import { axiosInstance } from '../../functions/axios';
import CONSTANTS from '../../constants/constants';

const SessionWarningModal = ({ open, setOpen }) => {
    const { t } = useTranslation();
    const twoMinutesCounter = useRef(null);
    const FETCH_USER_DETAILS_URL = process.env.REACT_APP_FETCH_USER_DETAILS_URL;
    const initialRemainingTime = CONSTANTS.WARNING_COUNTDOWN;
    const [remainingTime, setRemainingTime] = useState(initialRemainingTime);

    const fetchUserDetails = async () => {
        try {
            const response = await axiosInstance.post(FETCH_USER_DETAILS_URL);
            if (response.status === 200) {
                console.log('Done calling FETCH_USER_DETAILS_URL API');
            }
        } catch (error) {
            console.log('Logging error', error);
        }
    };

    useEffect(() => {
        if (open) {
            console.log('Modal is open, Checking for counterRef');
            if (!twoMinutesCounter.current) {
                console.log('Setting interval id in Ref');
                twoMinutesCounter.current = setInterval(
                    (remainingTime) => {
                        console.log(`Inside interval, ID is ${twoMinutesCounter.current}`);
                        console.log(`Inside interval, remaining time is ${remainingTime}`);
                        // if (remainingTime < 1) {
                        //     console.log(`Remaining time <1, Clearing interval, setting remainingTime to 0`);
                        //     clearInterval(twoMinutesCounter.current);
                        //     setRemainingTime(0);
                        // } else {
                        console.log(`Decrementing remaining time to ${remainingTime - 1}`);
                        setRemainingTime((remainingTime) => remainingTime - 1);
                        // }
                    },
                    1000,
                    remainingTime
                );
            }
        } else {
            console.log('Clearing interval because open === false');
            clearInterval(twoMinutesCounter.current);
            twoMinutesCounter.current = null;
        }
        // return () => {
        //     clearInterval(twoMinutesCounter.current);
        //     console.log('Clearing interval on Component unmount');
        // };
    }, [open, remainingTime]);
    // Not clearing interval - solved
    // Have not handled open == false
    // When user clicks on Extend and calls API, Timer should be reset - solved

    useEffect(() => {
        if (remainingTime < 1) {
            console.log(`Remaining time <1, Clearing interval, setting remainingTime to 0`);
            clearInterval(twoMinutesCounter.current);
            setRemainingTime(0);
        }
    }, [remainingTime]);

    useEffect(() => {
        if (!open) {
            setRemainingTime(CONSTANTS.WARNING_COUNTDOWN);
        }
    }, [open]);

    return (
        <Modal
            open={open}
            onHide={() => setOpen(false)}
            closeIcon={true}
            onClickCloseIcon={() => setOpen(false)}
            size='small'
            activeFocusTrap={true}
            minHeight='230px'
        >
            <Box display='flex' justifyContent='center' width='100%' marginTop='10%'>
                <Box>
                    <Typography variant='h4' id='paymentsList-typo-modal-text' fontWeight='bold'>
                        {t('loginPage.yourSessionWillExpire', {
                            remainingTime,
                        })}
                    </Typography>
                </Box>
            </Box>
            <Box
                position='absolute'
                bottom='0'
                py='1em'
                width='calc(100% - 80px)'
                display='flex'
                justifyContent='flex-end'
                borderTop='1px solid #333'
            >
                <Button
                    variant='light.primary'
                    disabled={remainingTime === 0 || remainingTime === CONSTANTS.WARNING_COUNTDOWN}
                    onClick={() => {
                        setOpen(false);
                        fetchUserDetails();
                        clearInterval(twoMinutesCounter.current);
                        twoMinutesCounter.current = null;
                    }}
                    id='paymentsList-button-modal-no'
                >
                    Extend session
                </Button>
            </Box>
        </Modal>
    );
};

export default SessionWarningModal;
